import { RateTableCarrier } from "@redotech/redo-model/rate-table/rate-table-mapping";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";
import { getPrettyCarrierName } from "@redotech/redo-web/carrier-service-labels";
import PackageIcon from "@redotech/redo-web/icon-old/package.svg";

export const SelectedCarrierFilter: AdvancedTableFilter = {
  type: AdvancedFilterType.ARRAY_TO_STRING,
  operators: [
    ArrayStringFilterOperator.ANY_OF,
    ArrayStringFilterOperator.ALL_OF,
    ArrayStringFilterOperator.NONE_OF,
  ],
  data: {
    name: "selectedCarrier",
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "carrier",
  Icon: PackageIcon,
  // Don't want to duplicate showing UPS SurePost, since it's the same as UPS
  // Eventually we should change this so that we use the Carriers enum instead of RateTableCarrier
  values: Object.values(RateTableCarrier).filter(
    (c) =>
      c !== RateTableCarrier.UPS_SUREPOST &&
      c !== RateTableCarrier.USPS_RETURNS,
  ),
  display: (item: RateTableCarrier) => getPrettyCarrierName(item),
  displayName: "Selected carrier",
};
